import { GlobalViewMutations } from './partials/global_view'
import { UserGroupMutations } from './partials/user_groups'
import { UserNewsMutations } from './partials/news'
import { UserProfileMutations } from './partials/user-profile'
import { UserTeamsMutations } from './partials/teams'

export const UserMutations = {
  ...GlobalViewMutations,
  ...UserGroupMutations,
  ...UserNewsMutations,
  ...UserProfileMutations,
  ...UserTeamsMutations,
}
